<template>
    <div class="dashboard__cards">
        <div class="card card--with-heading">
            <h4>
                <div class="card-title">Promedios</div>
                <DashboardFilters
                    v-show="!hideFilters"
                    ref="filtersComponent"
                    @filter="getNumberDashboard"
                    :dashboardTab="dashboardTab"
                    :isAdmin="isAdmin"
                    :organizations="organizations"
                    :filterFor="filterFor"
                />
            </h4>
            <div class="card-container">
                <div
                    v-for="(card, index) in dashboardNumber"
                    :key="card.name"
                    class="card"
                >
                    <div
                        class="donut-chart"
                        v-if="
                            index == 0 &&
                            !isNaN(dashboardNumber[0].deliveredAtOrigin)
                        "
                    >
                        <div id="chart">
                            <apexchart
                                type="donut"
                                :options="chartOptions"
                                :series="series"
                            ></apexchart>
                        </div>
                    </div>

                    <strong
                        class="card-number"
                        v-if="card.value && (index == 0 || index == 1)"
                        >{{ card.name.includes("Precio") ? "$ " : ""
                        }}{{
                            Number(card.value) % 1 === 0
                                ? Number(card.value).toLocaleString("de-DE")
                                : parseFloat(card.value).toLocaleString(
                                      "de-DE",
                                      { maximumFractionDigits: 2 }
                                  )
                        }}</strong
                    >
                    <strong
                        class="card-number"
                        v-else-if="
                            card.deliveredAtDestination &&
                            index != 0 &&
                            index != 1
                        "
                        >{{
                            card.deliveredAtDestination.replace(".", ",")
                        }}</strong
                    >

                    <strong class="card-number" v-else>-</strong>
                    <div
                        class="d-flex flex-direction-column justify-content-between labels"
                    >
                        <label class="text-center line-height-1">{{
                            card.name
                        }}</label>
                        <div class="pt-2 font-size-12-px">
                            <div
                                class="d-flex align-items-center"
                                :class="[
                                    index == 0
                                        ? 'color-destino'
                                        : 'color-grey-dark-1',
                                ]"
                                v-if="index == 0 || index == 1"
                            >
                                <vs-icon
                                    icon="label"
                                    class="font-size-12-px pr-1"
                                />
                                Entregados en destino:

                                {{ card.deliveredAtDestination + " " }}
                                {{ index == 1 ? "Kg" : "" }}
                            </div>
                            <div
                                class="d-flex align-items-center"
                                :class="[
                                    index == 0
                                        ? 'color-origen'
                                        : 'color-grey-dark-2',
                                ]"
                            >
                                <vs-icon
                                    icon="label"
                                    class="font-size-12-px pr-1"
                                />
                                Entregados en origen:
                                {{ card.deliveredAtOrigin + " " }}
                                {{ index == 1 ? "Kg" : "" }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="price-label">
                <span class="label"> * Todos los precios son sin IVA. </span>
            </div>
        </div>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import DashboardFilters from "./DashboardFilters.vue";
import gql from "graphql-tag";
import axios from "axios";
import { print } from "graphql";

const numberDashboard = gql`
    query numberDashboard(
        $currentUserToken: String!
        $scope: String!
        $scopedOrganizationId: Int
        $filters: DashboardFilterInput
    ) {
        numberDashboard(
            currentUserToken: $currentUserToken
            scope: $scope
            scopedOrganizationId: $scopedOrganizationId
            filters: $filters
        ) {
            name
            value
            deliveredAtDestination
            deliveredAtOrigin
        }
    }
`;

export default {
    name: "cards-dashboard",
    components: {
        DashboardFilters,
        apexchart: VueApexCharts,
    },

    props: {
        generalFilter: Object,
        hideFilters: Boolean,
        selectedType: String,
        dashboardTab: {
            type: String,
            required: true,
        },
        isAdmin: {
            type: Boolean,
            required: false,
            default: false,
        },
        organizations: {
            type: Array,
            required: false,
            default: () => {
                return [];
            },
        },
        filterFor: {
            type: String,
            required: false,
        },
        scopedOrganizationId: {
            type: Number,
            required: false,
            default: 0,
        },
    },
    data() {
        return {
            noData: undefined,
            userTypeSelected: null,
            dashboardNumber: {},
            series: [0],
            chartOptions: {
                labels: ["Origen", "Destino"],
                colors: ["#d3726b", "#82a8c9"],
                dataLabels: {
                    enabled: false,
                },
                chart: {
                    type: "donut",
                },
                legend: {
                    show: false,
                    position: "bottom",
                },
                // responsive: [
                //     {
                //         breakpoint: 480,
                //         options: {
                //             chart: {},
                //             legend: {
                //                 show: false,
                //                 position: "bottom",
                //             },
                //         },
                //     },
                // ],
            },
        };
    },
    mounted() {
        this.userTypeSelected = this.$refs.filtersComponent.globalType;
        this.$watch(
            "$refs.filtersComponent.globalType",
            (new_value, old_value) => {
                this.userTypeSelected = new_value;
                this.getNumberDashboard();
            }
        );
    },
    watch: {
        generalFilter: function (newVal, oldVal) {
            if (!this.generalFilter) return;

            this.getNumberDashboard(this.generalFilter);
        },
        scopedOrganizationId() {
            if (this.isAdmin) {
                this.getNumberDashboard();
            }
        },
        dashboardNumber(newValue, oldValue) {
            if (!isNaN(newValue[0].deliveredAtOrigin)) {
                this.series = [
                    parseFloat(newValue[0].deliveredAtOrigin.replace(",", ".")),
                    parseFloat(
                        newValue[0].deliveredAtDestination.replace(",", ".")
                    ),
                ];
            }
        },
    },
    methods: {
        getNumberDashboard(filter = this.$refs.filtersComponent) {
            this.isLoading = true;
            if (filter.dashboardTab !== "entity" && !filter.isGlobalFilter) {
                return;
            }

            let orgId =
                this.isAdmin && this.scopedOrganizationId
                    ? { scopedOrganizationId: this.scopedOrganizationId }
                    : {};

            // esto se agregó porque por algun motivo se mandaban peticiones con el weekFrom de esa seamana.
            // Se debería ver porque pasa eso y despues borrar esta línea.

            if (!filter.invertedWeekFrom) {
                return;
            }

            // Si se están usando los filtros globales se ajusta esto para que se pueda ejecutar correctamente la consulta
            // Sino, se usan los que se tienen por referencia.
            let isUsingGlobalFilter = filter.isGlobalFilter ? true : false;
            let usedFilter = {};
            if (isUsingGlobalFilter) {
                delete filter.isGlobalFilter;
                delete filter.invertedWeekFrom;
                usedFilter = filter;
            } else {
                usedFilter = {
                    weekFrom: filter.invertedWeekFrom,
                    weekTo: filter.invertedWeekTo,
                    state: filter.filter.state,
                    category: filter.filter.category[0]
                        ? filter.filter.category
                        : null,
                    type: this.userTypeSelected || filter.filter.type,
                    weight: filter.filter.weight,
                };
            }

            axios
                .get(`${process.env.VUE_APP_GRAPH_PATH}`, {
                    params: {
                        query: print(numberDashboard),
                        variables: Object.assign(
                            {
                                currentUserToken: localStorage.getItem(
                                    "USER_TOKEN"
                                ),
                                scope: this.dashboardTab,
                                filters: usedFilter,
                            },
                            orgId
                        ),
                    },
                })
                .then((res) => {
                    if (!res.data.errors) {
                        this.dashboardNumber = res.data.data.numberDashboard;
                        // chequeo si todos los resultados que se trajeron son vacios.
                        this.noData =
                            this.dashboardNumber.filter(
                                (obj) =>
                                    obj.deliveredAtDestination !== "-" &&
                                    obj.deliveredAtOrigin !== "-"
                            ).length === 0;
                        this.$emit("cardDashboardNoData", this.noData);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        filterByUser(type) {
            this.$refs.filtersComponent.changeType(type);
            this.$refs.filtersComponent.globalType = type;
        },
    },
};
</script>
<style scoped>
</style>
